import * as sendData from './flatbufferscodec'
import { socket } from './websocketplugin'

export const sendLogin = function (payload) {
  if (socket) {
    const data = sendData.credentialsToByteBuffer(payload.companyName, payload.userName, payload.password, payload.type, payload.typeID)
    socket.send(data)
  }
}

export const sendChat = function (text, roomId) {
  if (socket) {
    const data = sendData.chatToByteBuffer(text, 0, roomId)
    socket.send(data)
  }
}

export const sendAllHistoryChat = function (listRoomIds) {
  if (socket) {
    const data = sendData.historyAllChatToByteBuffer(listRoomIds)
    socket.send(data)
  }
}

export const sendHistoryChat = function (roomId, pagingStartTime, pagingSize) {
  if (socket) {
    const data = sendData.historyChatInRoomToByteBuffer(roomId, pagingStartTime, pagingSize)
    socket.send(data)
  }
}

export const sendGetRoom = function () {
  if (socket) {
    const data = sendData.listRoomToByteBuffer()
    socket.send(data)
  }
}

export const sendReadMessage = function (roomId, userId, userName) {
  if (socket) {
    const data = sendData.readMessageToByteBuffer(roomId, userId, userName)
    socket.send(data)
  }
}

export const sendIncommingMessage = function (roomId, userId, userName, status) {
  if (socket) {
    const data = sendData.incommingMessageToByteBuffer(roomId, userId, userName, status)
    socket.send(data)
  }
}

export const sendAppStatus = function (status) {
  if (socket) {
    const data = sendData.appStatusToByteBuffer(status)
    socket.send(data)
  }
}

export const sendAppNotification = function (phoneType, deviceId, token) {
  if (socket) {
    const data = sendData.appNotificationToByteBuffer(phoneType, deviceId, token)
    socket.send(data)
  }
}
